export default {
      id: "ic-media-20px-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#ic-media-20px",
      toString: function () {
        return this.url;
      }
    }